import React, { Component } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';

class PageFooter extends Component {
  render() {
    return (
      <Navbar bg="dark" variant="dark" fixed="bottom" style={footerStyle}>
        <Nav className="justify-content-end" style={footerTextSyle}>
          <Nav.Link target="_blank" href="https://twitter.com/TrollgenStudios">
            {' '}
            Support Trollgen Studios{' '}
          </Nav.Link>
        </Nav>
      </Navbar>
    );
  }
}

const footerStyle = {
  margin: '30px 0px 0px 0px',
  padding: '1px',
  float: 'bottom',
};

const footerTextSyle = {
  width: '100%',
  color: '#fff',
};

export default PageFooter;
